export default __webpack_public_path__ + "maps-examples-simple-map-view-1200-66b4b6293efb6caedbe20afd294a3875.png";